import {
    PictogramBigBenSmall,
    PictogramCitySmall,
    PictogramCoastSmall,
    PictogramRuralSmall
} from '@zoopla-eng/zds-components/pictograms';
import { PICTOGRAMS_REMOTE_SPRITE_URL } from '@zoopla/assets';
import { AreaId } from './SearchSuggestionsTownsAndCities.types';

export const sectionIcon = (id: AreaId) => {
    switch (id) {
        case 'in-the-city':
            return (
                <PictogramCitySmall
                    remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
                    backgroundColor="graphicSellingLight"
                />
            );
        case 'on-the-coast':
            return (
                <PictogramCoastSmall
                    remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
                    backgroundColor="graphicBackgroundAccentLight"
                />
            );
        case 'rural-and-countryside':
        case 'trending-areas':
            return (
                <PictogramRuralSmall
                    remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
                    backgroundColor="graphicPriceLight"
                />
            );
        case 'popular-locations':
            return (
                <PictogramBigBenSmall
                    remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
                    backgroundColor="graphicImprovingLight"
                />
            );
        default:
            return undefined;
    }
};
